import { NgModule } from '@angular/core';
import { BrowserModule } from '@angular/platform-browser';
import { AppRoutingModule } from './app-routing.module';
import { AppComponent } from './app.component';
import { NavItemModule } from './common/utilities/nav-item/nav-item/nav-item.module';
import { ToggleModule } from './common/utilities/toggle/toggle/toggle.module';
import { TopbarModule } from "./common/components/navbar/topbar/topbar.module";
import { SidebarModule } from "./common/components/navbar/sidebar/sidebar.module";
import { InputModule } from './common/utilities/input/input/input.module';
import { ButtonFillModule } from './common/utilities/buttons/button-fill/button-fill/button-fill.module';
import { SigninModule } from './pages/signin/signin.module';
import { DashboardModule } from './pages/dashboard/dashboard.module';
import { RegisterModule } from './pages/register/register.module';
import { SelectModule } from './common/utilities/select/select/select.module';
import { CheckBoxModule } from './common/utilities/check-box/check-box/check-box.module';
import { HttpClientModule, HTTP_INTERCEPTORS } from '@angular/common/http';
import { AuthInterceptorInterceptor } from './auth/auth-interceptor.interceptor';
import { WebhooksComponent } from './pages/webhooks/webhooks.component';
import { WebhooksModule } from './pages/webhooks/webhooks.module';
import { BrowserAnimationsModule } from '@angular/platform-browser/animations';
import { TableModule } from './common/utilities/table/table.module';
import { SettingsModule } from './pages/settings/settings.module';
import { ModalModule } from './common/components/modal/modal.module';
import { HomeModule } from './pages/home/home.module';
import { DropdownModule } from './common/utilities/dropdown/dropdown.module';
import { ModalWrapperComponent } from './common/components/modal-wrapper/modal-wrapper.component';
import { ModalService } from './service/modal.service';
import { ModalWrapperModule } from './common/components/modal-wrapper/modal-wrapper.module';
import { CreateApiKeyModule } from './common/modals/create-api-key/create-api-key.module';
import { ButtonOutlineModule } from './common/utilities/buttons/button-outline/button-outline/button-outline.module';
import { RequestsModule } from './pages/requests/requests.module';
import { MultiSelectCheckboxModule } from './common/utilities/multi-select-checkbox/multi-select-checkbox.module';
import { CopyTextModule } from './common/utilities/copy-text/copy-text.module';
import { SingleWebhookModule } from './pages/single-webhook/single-webhook.module';
import { ResetPasswordModule } from './pages/reset-password/reset-password.module';
import { UpdatePasswordModule } from './pages/update-password/update-password.module';
import { NgxSkeletonLoaderModule } from 'ngx-skeleton-loader';
import { CopyTextSingleLineModule } from './common/utilities/copy-text-single-line/copy-text-single-line.module';
import { BadgeModule } from 'primeng/badge';
import { FilterModule } from './common/components/filter/filter.module';
import { NZ_I18N } from 'ng-zorro-antd/i18n';
import { en_US } from 'ng-zorro-antd/i18n';
import { registerLocaleData } from '@angular/common';
import en from '@angular/common/locales/en';
import { FormsModule } from '@angular/forms';
import { PaginationModule } from './common/components/pagination/pagination.module';
import { RequestTableModule } from './common/components/request-table/request-table.module';
import { WebhookTableModule } from './common/components/webhook-table/webhook-table.module';
import { ApiTableModule } from './common/components/api-table/api-table.module';


registerLocaleData(en);

@NgModule({
    declarations: [
        AppComponent,
    ],
    imports: [
      BrowserModule,
      AppRoutingModule,
      BrowserAnimationsModule,
      NavItemModule,
      ToggleModule,
      InputModule,
      TopbarModule,
      SidebarModule,
      ButtonFillModule,
      ButtonOutlineModule,
      SigninModule,
      DashboardModule,
      RegisterModule,
      SelectModule,
      CheckBoxModule,
      HttpClientModule,
      WebhooksModule,
      TableModule,
      SettingsModule,
      ModalModule,
      HomeModule,
      DropdownModule,
      ModalWrapperModule,
      CreateApiKeyModule,
      RequestsModule,
      MultiSelectCheckboxModule,
      CopyTextModule,
      SingleWebhookModule,
      ResetPasswordModule,
      CopyTextSingleLineModule,
      BadgeModule,
      FilterModule,
      PaginationModule,
      UpdatePasswordModule,
      RequestTableModule,
      WebhookTableModule,
      ApiTableModule,
      NgxSkeletonLoaderModule.forRoot({
        theme: {
            // Enabliong theme combination
            extendsFromRoot: true,
            // ... list of CSS theme attributes
            height: '40px',
            width: '100%',
            margin: '10px 0px'
          },
      } ),
      FormsModule
  ],
    providers: [
        { provide: HTTP_INTERCEPTORS, useClass: AuthInterceptorInterceptor, multi: true},
        { provide: NZ_I18N, useValue: en_US }
    ],
    bootstrap: [AppComponent],
    
})
export class AppModule { }
